// material-ui
import { Theme } from '@mui/material/styles';

// ==============================|| OVERRIDES - TOOLTIP ||============================== //
// Balão roxo sólido com texto branco: alto contraste garantido em light e dark,
// independente do preset de cor (antes usava o gradiente da toolbar, que podia
// ficar claro/escuro e deixar o texto sem contraste no modo light).

export default function Tooltip(theme: Theme) {
  return {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: `${theme.palette.primary.main} !important`,
          backgroundImage: 'none !important',
          color: `${theme.palette.primary.contrastText} !important`,
          borderRadius: theme.shape.borderRadius,
          fontSize: '0.75rem',
          fontWeight: 500,
          padding: '8px 12px',
          boxShadow: theme.shadows[6]
        },
        arrow: {
          color: theme.palette.primary.main
        }
      }
    }
  };
}
